<template>
	<v-sheet elevation="0">
		<CommonFlame :title="title" :maxWidth="'auto'">
			<v-row no-gutters justify="end">
				<ConstructionCostApprovalDialog
					:title="'原価予算承認'"
					@approve="approveCost('budget')"
					@reject="rejectCost('budget', $event)"
				/>
				<v-btn
					class="ml-2"
					color="secondary"
					@click="$router.push({ name: 'construction_edit_index', params: { id: 'TODO' } })"
				>
					<v-icon class="mr-1">mdi-pencil</v-icon> 原価予算計算
				</v-btn>
				<ConstructionCostApprovalDialog
					:title="'原価実績承認'"
					@approve="approveCost('budget')"
					@reject="rejectCost('budget', $event)"
				/>
				<v-btn
					class="ml-2"
					color="secondary"
					@click="
						$router.push({
							name: 'construction_edit_index',
							params: { id: 'TODO' },
							query: { cost_type: 'actual' },
						})
					"
				>
					<v-icon class="mr-1">mdi-pencil</v-icon> 原価実績計算
				</v-btn>
			</v-row>
			<ConstructionCostArea :costItems="costItems" :isActual="isActual" :isShow="isShow" />
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"

import CommonFlame from "../shared/CommonFlame.vue"
import ShowDetailRecord from "../shared/ShowDetailRecord.vue"
import ConstructionCostArea from "./components/ConstructionCostArea.vue"
import ConstructionCostApprovalDialog from "./components/ConstructionCostApprovalDialog.vue"

export default {
	components: {
		CommonFlame,
		ShowDetailRecord,
		ConstructionCostArea,
		ConstructionCostApprovalDialog,
	},
	data() {
		return {
			title: "原価計算",
			construction: {},
			matter: {},
			costType: "budget",
			costItems: sampleCostItems(),
			rules,
			isActual: true,
			isShow: true,
		}
	},
	mounted() {
		this.fetchCost()
	},
	methods: {
		fetchCost() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/costs/${this.$route.params.id}`
			axios
				.get(url, { headers })
				.then((res) => {
					this.requirement = res.data.requirement
					this.matter = res.data.matter
					// TODO MatterProductsの見積系項目を実績に初期として入れておく
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		approveCost(type) {
			// TODO 原価承認処理
			const headers = authenticate.setHeader()
			const url = `/erp/v1/`
			axios
				.post(url, params, {
					headers,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "",
					})
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
		rejectCost(type, reason) {
			// TODO 原価差し戻し処理
			const headers = authenticate.setHeader()
			const params = { reason }
			const url = `/erp/v1/`
			axios
				.post(url, params, {
					headers,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "",
					})
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
	},
}

function sampleCostItems() {
	const defaultColumn = [
		{
			name: "項目",
			width: 200,
			input: true,
			onlyBudget: true,
		},
		{
			name: "種類",
			width: 120,
			input: true,
			onlyBudget: true,
		},
		{
			name: "寸法・仕様",
			width: 100,
			input: true,
			onlyBudget: true,
		},
		{
			name: "数量",
			width: 80,
			input: true,
		},
		{
			name: "単位",
			width: 80,
			input: true,
			onlyBudget: true,
		},
		{
			name: "単価",
			width: 100,
			input: true,
		},
		{
			name: "金額",
			width: 100,
			input: false,
		},
		{
			name: "資材管理費",
			width: 100,
			input: true,
		},
		{
			name: "工場間接費",
			width: 100,
			input: false,
		},
		{
			name: "工場原価",
			width: 100,
			input: true,
		},
		{
			name: "販管費",
			width: 100,
			input: false,
		},
		{
			name: "総原価",
			width: 100,
			input: false,
		},
		{
			name: "外部費用",
			width: 100,
			input: true,
		},
	]
	return [
		{
			name: "ゴム材料",
			columns: defaultColumn,
		},
		{
			name: "液状ゴム",
			columns: defaultColumn,
		},
		{
			name: "接着剤",
			columns: defaultColumn,
		},
		{
			name: "コート",
			columns: defaultColumn,
		},
		{
			name: "リース・消耗品(日数なし)",
			columns: defaultColumn,
		},
		{
			name: "リース・消耗品(日数あり)",
			columns: [
				{
					name: "項目",
					width: 200,
					input: true,
					onlyBudget: true,
				},
				{
					name: "種類",
					width: 120,
					input: true,
					onlyBudget: true,
				},
				{
					name: "寸法・仕様",
					width: 100,
					input: true,
					onlyBudget: true,
				},
				{
					name: "数量",
					width: 80,
					input: true,
				},
				{
					name: "単位",
					width: 80,
					input: true,
					onlyBudget: true,
				},
				{
					name: "単価",
					width: 100,
					input: true,
				},
				{
					name: "日数",
					width: 100,
					input: true,
				},
				{
					name: "金額",
					width: 100,
					input: false,
				},
				{
					name: "運送費",
					width: 100,
					input: true,
				},
				{
					name: "資材管理費",
					width: 100,
					input: true,
				},
				{
					name: "工場間接費",
					width: 100,
					input: false,
				},
				{
					name: "工場原価",
					width: 100,
					input: true,
				},
				{
					name: "販管費",
					width: 100,
					input: false,
				},
				{
					name: "総原価",
					width: 100,
					input: false,
				},
				{
					name: "外部費用",
					width: 100,
					input: false,
				},
				{
					name: "備考",
					width: 200,
					input: true,
				},
			],
		},
		{
			name: "人件費",
			columns: defaultColumn,
		},
		{
			name: "宿泊費",
			columns: defaultColumn,
		},
		{
			name: "輸送費",
			columns: defaultColumn,
		},
		{
			name: "交通費",
			columns: defaultColumn,
		},
	]
}
</script>
